// extracted by mini-css-extract-plugin
module.exports = {"tabLabel":"tab-label-c22","tabLabelActive":"tab-label_active-55d"};